import { Injectable } from '@angular/core';
import { Illustration } from '../../../shared/models/illustration';

@Injectable({
  providedIn: 'root'
})

export class SimulationConstantsService {
  CONSTANTS = {
    PATTERN: {
      // EMAIL_REGEX: /^[ ]{0,}[a-zA-Z0-9]{1}(?!.*[.]{2})[\.a-zA-Z0-9\]/(?:[!#$%&'*+^_`{|}~-]{2,249}@[a-zA-Z0-9-\.]{1,250}\.[a-zA-Z]{2,64}[ ]{0,}$/,
      // Fixed via SilValidators.email
      // Allowing space before and after the email so that 'by-mistake' space can be taken care and trimming the value before saving
      // NAME_REGEX: /^([a-zA-Zàâçéèêëîïôûùüÿñæœ])+(?:-[a-zA-Zàâçéèêëîïôûùüÿñæœ]+)*$/
      NAME_REGEX: /^(\s*)+([a-zA-Zàâçéèêëîïôûùüÿñæœ])+((?:([\s-])+(?:[a-zA-Zàâçéèêëîïôûùüÿñæœ]+))*)+(\s*)$/
      // Allowing space before and after the name so that 'by-mistake' space can be taken care and trimming the value before saving
    }
  };

  GUIDANCE_CONTENT = {
    PRODUCT_DETAILS: {
      PRODUCT_TYPE_21: {
        id: 'productGuidance21',
        adobestepname: 'market scenarios br21 guidance',
        title: 'Simulation.ProductDetails.Guidance_Title',
        continue: 'Simulation.ProductDetails.Guidance_Continue',
        context1: 'Simulation.ProductDetails.Guidance_Branch21_AGDigital_Context_1',
        context2: 'Simulation.ProductDetails.Guidance_Branch21_AGDigital_Context_2',
        brokerContext1: 'Simulation.ProductDetails.Guidance_Branch21_Broker_Context_1',
        brokerContext2: 'Simulation.ProductDetails.Guidance_Branch21_Broker_Context_2',
        items: [
          {
            illustration: Illustration.NeutralScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch21_Section1_title',
            content: 'Simulation.ProductDetails.Guidance_Branch21_Section1_text'
          },
          {
            illustration: Illustration.PositiveScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch21_Section2_title',
            content: 'Simulation.ProductDetails.Guidance_Branch21_Section2_text'
          }]
      },
      PRODUCT_TYPE_23: {
        id: 'productGuidance23',
        adobestepname: 'market scenarios br23 guidance',
        title: 'Simulation.ProductDetails.Guidance_Title',
        continue: 'Simulation.ProductDetails.Guidance_Continue',
        context1: 'Simulation.ProductDetails.Guidance_Branch23_Context_1',
        context2: 'Simulation.ProductDetails.Guidance_Branch23_Context_2',
        items: [
          {
            illustration: Illustration.StressScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch23_Section1_title',
            content: 'Simulation.ProductDetails.Guidance_Branch23_Section1_text'
          },
          {
            illustration: Illustration.NegativeScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch23_Section2_title',
            content: 'Simulation.ProductDetails.Guidance_Branch23_Section2_text'
          },
          {
            illustration: Illustration.NeutralScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch23_Section3_title',
            content: 'Simulation.ProductDetails.Guidance_Branch23_Section3_text'
          },
          {
            illustration: Illustration.PositiveScenario,
            title: 'Simulation.ProductDetails.Guidance_Branch23_Section4_title',
            content: 'Simulation.ProductDetails.Guidance_Branch23_Section4_text'
          }
        ]
      }
    }
  };

  INCOME_PERCENTAGE = [
    {
      SmartInvestLineProductTypeCode: 0,
      positive: '4',
      negative: '5',
      calculation: {
        tension: -5,
        negative: -5,
        intermediary: -5,
        positive: 4
      }
    },
    {
      SmartInvestLineProductTypeCode: 1,
      positive: '43',
      negative: '7',
      calculation: {
        tension: -33,
        negative: -7,
        intermediary: 15,
        positive: 43
      }
    },
    {
      SmartInvestLineProductTypeCode: 2,
      positive: '58',
      negative: '24',
      calculation: {
        tension: -55,
        negative: -24,
        intermediary: 10,
        positive: 58
      }
    },
    {
      SmartInvestLineProductTypeCode: 3,
      positive: '95',
      negative: '32',
      calculation: {
        tension: -67,
        negative: -32,
        intermediary: 14,
        positive: 95
      }
    },
    {
      SmartInvestLineProductTypeCode: 4,
      positive: '6',
      negative: '3',
      image: './assets/images/product-uppie-moon.svg',
      calculation: {
        tension: -3,
        negative: -3,
        intermediary: -3,
        positive: 6
      }
    },
    {
      SmartInvestLineProductTypeCode: 5,
      positive: '46',
      negative: '5',
      image: './assets/images/product-uppie-star-go.svg',
      calculation: {
        tension: -32,
        negative: -5,
        intermediary: 18,
        positive: 46
      }
    },
    {
      SmartInvestLineProductTypeCode: 6,
      positive: '63',
      negative: '19',
      image: './assets/images/product-uppie-star-run.svg',
      calculation: {
        tension: -52,
        negative: -19,
        intermediary: 15,
        positive: 63
      }
    },
    {
      SmartInvestLineProductTypeCode: 7,
      positive: '95',
      negative: '5',
      image: './assets/images/product-uppie-star-fly.svg',
      calculation: {
        tension: -67,
        negative: -30,
        intermediary: 18,
        positive: 95
      }
    }
  ];
}
